import React, { PropsWithChildren } from 'react';
import {
  QueryClient,
  QueryClientProvider,
  useQuery as useQueryLib,
  useInfiniteQuery as useInfiniteQueryLib,
  useMutation as useMutationLib,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import {
  DELAY_SCALE_FACTOR,
  MAX_TIMEOUT,
  MIN_TIMEOUT,
  USE_JITTER,
} from './constants';

export const store = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retryOnMount: false,
      // Limits retry attempts count
      retry: false,
      // Prevents spamming server with thousands of requests
      // Algorithm inside guarantees exponential time increase between attempts
      retryDelay: (seed: number) => {
        const randomValue = USE_JITTER ? Math.random() + 1 : 1;
        const calculatedTimeout = randomValue * MIN_TIMEOUT * (DELAY_SCALE_FACTOR ** seed);
        return Math.min(MAX_TIMEOUT, calculatedTimeout);
      },
      staleTime: 5000,
      cacheTime: 300000,
    },
  },
});

export const useQuery = useQueryLib;

export const useInfiniteQuery = useInfiniteQueryLib;

export const useMutation = useMutationLib;

export const StoreProvider = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={store}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
